// Intent: a stable per-installation id required by the backend's anti-SMS-pumping
// rate limits (max 5 codes/device/day) and by app_device push registration. It is
// NOT a user identifier — privacy rule: nothing here identifies a person. Generated
// once, kept in the local kv for the app's lifetime.

import { getDb } from '@/db';

const KV_DEVICE_ID = 'device_id';

let cached: string | null = null;

export async function getDeviceId(): Promise<string> {
  if (cached) return cached;
  const db = await getDb();
  const existing = await db.getKv(KV_DEVICE_ID);
  if (existing) {
    cached = existing;
    return existing;
  }
  const fresh = randomUuid();
  await db.setKv(KV_DEVICE_ID, fresh);
  cached = fresh;
  return fresh;
}

// Math.random is fine here: the id only needs to be unique-ish per install,
// it protects nothing (no crypto dependency needed for this).
function randomUuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
